import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import Button from "ds/Button";

import * as S from "./RoutesDescription.styles";

export const RoutesDescription = () => {
  const { formatMessage } = useIntl();

  return (
    <S.RoutesDescriptionRoot>
      <Typography.BodyText size="small">
        {formatMessage(
          { id: "environment.services.configuration.routes" },
          {
            appName: APP_NAME,
            code: txt => <S.Code variant="inline">{txt}</S.Code>,
            br: () => <br />,
            appRouteFilePath: formatMessage({
              id: "app_routes_file_path"
            })
          }
        )}
      </Typography.BodyText>

      <Typography.BodyText size="small">
        {formatMessage<React.ReactNode>(
          { id: "environment.services.configuration.routes_doc" },
          {
            a: txt => (
              <Button
                analyticId="links.documentation.routes"
                variant="link"
                href={formatMessage({
                  id: "links.documentation.routes"
                })}
              >
                {txt}
              </Button>
            )
          }
        )}
      </Typography.BodyText>
    </S.RoutesDescriptionRoot>
  );
};
